<template>
  <div class="template-modal-page">
    <Modal
      header="Header"
      :full-screen="true"
    >
      <template #content>
        <div class="confirmation">
          <i class="bi bi-check-lg icon" />
          <p class="heading--large">
            Success
          </p>
          <p class="body--medium">
            message
          </p>
        </div>
      </template>
      <template #footer>
        <button class="button-secondary">
          Button
        </button>
        <button class="button-utility">
          Button
        </button>
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from "@/components/template/modal/index.vue";

export default {
  name: 'TemplateModalPage',
  components: {
    Modal,
  }
};
</script>

<style lang="scss">
.template-modal-page {
  width: 100%;
  height: 100vh;
  background: rgb(103, 100, 100);
  .confirmation {
    @include stack-space($space-small);
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }
  .icon {
    padding: $space-medium;
    border-radius: $radius-round;
    color: $color-white;
    background-color: $color-green-dark;
  }
}
</style>
